// src/utils/aviso.js
// ============================================================================
// Sistema global de AVISOS (toasts) — reemplaza los alert() arcaicos.
// ----------------------------------------------------------------------------
// Es un singleton con un mini event-emitter, NO un hook. Por eso se puede
// llamar desde CUALQUIER lado: componentes React, helpers, archivos utils/,
// callbacks de Firestore, etc. — sin props ni context.
//
// Uso:
//   import aviso from '../../utils/aviso';
//   aviso.exito('Pedido guardado correctamente');
//   aviso.error('No se pudo guardar: ' + e.message);
//   aviso.info('No se encontraron pedidos con esos filtros');
//   aviso.advertencia('Revisá los campos marcados');
//
//   // duración custom (ms); 0 = no se cierra solo (queda hasta que lo cierren)
//   aviso.info('Procesando…', { duracion: 0 });
//
// El contenedor <ToastContainer /> (montado UNA sola vez en App.js) escucha
// estos avisos y los pinta. El look vive en globals.css (bloque "TOASTS"):
// cambiar uno = cambiar todos. Tokenizado → claro y oscuro automáticos.
// ============================================================================

let suscriptores = [];
let contador = 0;

function emitir(tipo, mensaje, opciones = {}) {
  // Ignorar mensajes vacíos (evita toasts fantasma).
  if (mensaje == null || mensaje === '') return null;

  const toast = {
    id: ++contador,
    tipo,                 // 'exito' | 'error' | 'advertencia' | 'info'
    mensaje: String(mensaje),
    // Los errores quedan un poco más para alcanzar a leerlos.
    duracion: opciones.duracion != null
      ? opciones.duracion
      : (tipo === 'error' ? 6000 : 4000),
  };

  suscriptores.forEach((fn) => fn(toast));
  return toast.id;
}

const aviso = {
  exito:       (mensaje, opciones) => emitir('exito', mensaje, opciones),
  error:       (mensaje, opciones) => emitir('error', mensaje, opciones),
  advertencia: (mensaje, opciones) => emitir('advertencia', mensaje, opciones),
  info:        (mensaje, opciones) => emitir('info', mensaje, opciones),

  // Suscripción interna usada por <ToastContainer>. Devuelve la función para
  // desuscribirse (se llama en el cleanup del useEffect).
  _suscribir(fn) {
    suscriptores.push(fn);
    return () => { suscriptores = suscriptores.filter((s) => s !== fn); };
  },
};

export default aviso;
